// VerifyEmail.jsx
import React, { useEffect, useState } from "react";
import { getAuth, sendEmailVerification, signOut } from "firebase/auth";
import { auth } from "../../utilities/firebaseConfig";
import { Link, useNavigate } from "react-router-dom";
import loginbg from "../../assets/loginbg.jpg";

function VerifyEmail() {
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  const resendVerification = async () => {
    if (auth.currentUser) {
      try {
        await sendEmailVerification(auth.currentUser);
        setMessage("Verification email sent again! Check your inbox.");
      } catch (err) {
        console.error(err.message);
        setMessage(err.message);
      }
    }
  };

  const [openMenu, setOpenMenu] = useState(true);
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      setIsVisible(currentScrollY < lastScrollY);
      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  const handleSignOut = async () => {
    const auth = getAuth();
    try {
      await signOut(auth);
      console.log("User signed out");
      navigate("/login"); // redirect to login page
    } catch (error) {
      console.error("Error signing out:", error);
    }
  };

  return (
    <div className='authbody'>
      <div className='authspagecnt'>
        <div className='signin_cnt'>
          <Link to='/' className='profixlogo'>
            ProfixExpress
          </Link>
          <div className='signincntbdy'>
            <div>
              <h2 className='signin_title'>Your email is not verified.</h2>
              <div className='thespace'></div>
              <p className='dnthaacnt'>
                Please check your email and verify your account.
              </p>
              <div className='thespacee'></div>
              <button
                className='thesigninbtn resevs'
                onClick={resendVerification}
              >
                Resend Verification Email
              </button>
              <div className='thespacee '></div>
              <button className='thesigninbtn lsasa' onClick={handleSignOut}>
                Continue
              </button>
              {message && <p>{message}</p>}
            </div>
          </div>
        </div>
        <div className='signinimagecnt'>
          <img className='signiimg' src={loginbg} alt='' />
        </div>
      </div>
    </div>
  );
}

export default VerifyEmail;
